import React from 'react';
import demoBg from '../../assets2/backgrounds/demo-bg.png';
import alureDemo from '../../assets2/demos/AlureDemo.mov';
import alureRender from '../../assets2/demos/AlureRender.mov';
import setupImage from '../../assets/images/setup.JPG';
import './Demo.css';

const Demo = () => {
  return (
    <div className="demo-container">
      <div className="demo-hero">
        <div className="demo-hero-background">
          <img src={demoBg} alt="Demo Background" />
          <div className="demo-hero-overlay"></div>
        </div>
        <div className="demo-hero-content">
          <h1>What's Canopy Systems?</h1>
          <p>See our advanced plant monitoring and automation technology in action</p>
        </div>
      </div>
      
      <div className="demo-content">
        <div className="demo-section">
          <h2>Product Demonstration</h2>
          <p>Watch our system in action as it monitors and controls plant environments with precision accuracy.</p>
          
          <div className="demo-videos">
            <div className="demo-video-card">
              <h3>System Setup & Configuration</h3>
              <div className="demo-setup-image-container">
                <img 
                  src={setupImage} 
                  alt="Canopy Systems Setup" 
                  className="demo-setup-image"
                />
              </div>
              <p>Complete setup demonstration showing sensor placement and system configuration for optimal plant monitoring.</p>
            </div>
            
            <div className="demo-video-card">
              <h3>Live Demo Video</h3>
              <div className="youtube-embed-container">
                <iframe
                  src="https://www.youtube.com/embed/RGl61nl-LBY"
                  title="Canopy Systems Live Demo"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="youtube-iframe"
                ></iframe>
              </div>
              <p>Watch our system in action with real-time monitoring and automated plant care responses.</p>
            </div>
          </div>
        </div>
        
        <div className="demo-features">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">
                <i className="ri-sensor-line"></i>
              </div>
              <h3>Precision Sensors</h3>
              <p>High-accuracy sensors for temperature, humidity, light, and soil moisture monitoring.</p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <i className="ri-wifi-line"></i>
              </div>
              <h3>Wireless Connectivity</h3>
              <p>Seamless wireless communication between sensors and control systems.</p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <i className="ri-dashboard-line"></i>
              </div>
              <h3>Real-time Dashboard</h3>
              <p>Live monitoring dashboard with intuitive controls and data visualization.</p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <i className="ri-robot-line"></i>
              </div>
              <h3>Automated Control</h3>
              <p>Intelligent automation for irrigation, lighting, and climate control systems.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demo;
